module.exports = __webpack_public_path__ + "img/psv-logo-icon.95ae6f9a.png";